import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { useQueryClient } from '@tanstack/react-query';

export interface SearchBarComponentProps {
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
};

export default function SearchBarComponent(props: SearchBarComponentProps) {
  const {
    setSearchQuery,
  } = props;

  // get queryClient
  const queryClient = useQueryClient();

  // local state for search
  const [search, setSearch] = useState('');

  // Update handler
  const handleSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      setSearchQuery(search);
    }
  };

  return (
    <Paper
      component="form"
      sx={{
        p: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '50%'
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Search... Press Enter key or Search icon to submit search query"
        inputProps={{ 'aria-label': 'search...' }}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        onKeyDown={handleSearchKeyDown}
      />
      <IconButton
        onClick={() => {
          setSearch('');
          setSearchQuery('');
          // invalidate query to get correct totalCount in the DataTable
          queryClient.invalidateQueries({ queryKey: ['sigcap_datatable'] });
        }}
        size="small"
      >
        <ClearIcon />
      </IconButton>
      <IconButton
        sx={{ p: '10px' }}
        aria-label="search"
        onClick={() => {
          setSearchQuery(search);
        }}
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
